import { STREAM_TYPE } from 'services/CameraStream/config';
import { ACTION_ARGS, ACTION_NAMES } from '../configuration';
export default class ConfigureCameraStreamAction {
    #cameraStream;
    #action;
    #actionArguments = new Map();

    constructor(cameraStream, action, initialArgs, onCompletition) {
        this.#cameraStream = cameraStream;
        this.#action = action;
        this.update(initialArgs, onCompletition);
    }

    update(args, onCompletion = () => {}) {
        if (args === ACTION_ARGS[ACTION_NAMES.CONFIGURE_CAMERA_STREAM].INVALIDATE_STREAM_CONFIGURATION) {
            this.#invalidate();
            return;
        }
        const camConfig = args?.[0];
        const streamType = camConfig?.videoData?.streamType;

        if (!streamType) {
            console.log('[UpdateCameraStreamConfigurationAction] update():Failed to update action. No streamType provided ');
            return;
        }
        this.#actionArguments.set(streamType, { args, onCompletion });
    }

    async execute() {
        if (!this.shouldExecute) return;
        await this.#executeAction(STREAM_TYPE.SUB);
        await this.#executeAction(STREAM_TYPE.MAIN);
    }

    async #executeAction(streamType) {
        const action = this.#action;
        const actionArguments = this.#actionArguments.get(streamType)?.args;
        const onCompletion = this.#actionArguments.get(streamType)?.onCompletion;

        if (actionArguments) {
            this.#actionArguments.delete(streamType);
            await this.#cameraStream[action](...actionArguments);
            onCompletion?.();
        }
    }

    #invalidate() {
        this.#actionArguments.values().forEach((streamType) => {
            const camConfig = streamType?.args?.[0];
            if (!camConfig || typeof camConfig !== 'object') {
                console.log('[UpdateCameraStreamConfigurationAction] #invalidate():Failed to invalidate camera stream configuration.');
                return;
            }
            camConfig.invalidated = true;
        });
    }
    get shouldExecute() {
        return this.#actionArguments.size && (this.#actionArguments.get(STREAM_TYPE.SUB) || this.#actionArguments.get(STREAM_TYPE.MAIN));
    }

    remove() {
        this.#actionArguments = new Map();
    }
}
